import { Booking } from "../../../../redux/types";

interface Props {
  booking: Booking;
}

const MeetingButton: React.FC<Props> = (props) => {
  const { booking } = props;
  const url = booking.meetingUrl;
  return (
    <div style={{ direction: "ltr" }} className="w-full col-span-2 rounded-md bg-pkc-dark-blue-15 text-pkc-dark-blue">
      <div style={{ direction: "rtl" }} className="flex flex-row gap-3 m-3">
        <div className="flex flex-row items-center content-center w-full text-sm font-bold text-center sm:text-md ">
          <div className="flex justify-center flex-1 ">
            <i className="pl-1 far fa-copy" />

            <p className="hover:cursor-pointer" onClick={() => navigator.clipboard.writeText(url)}>
              کپی کردن لینک
            </p>
          </div>
        </div>
        <a
          style={{ backgroundColor: "#e6f4cb" }}
          className="flex flex-row items-center content-center w-full p-2 text-sm text-center rounded sm:text-md text-pkc-primary focus:text-green-900 "
          href={url}
          target="_blank"
        >
          <i className="far fa-external-link-square" />
          <div className="flex-1 text-center">ورود به اتاق گفتگو</div>
        </a>
      </div>
    </div>
  );
};

export default MeetingButton;
